import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { ConsumerFlowStore } from '../Redux/Store';

export const useCxSelector: TypedUseSelectorHook<ConsumerFlowStore> = useSelector;
